import React, { useState } from "react";
import CrudModalList from "./CrudModalList";
import { deleteCompanyContacts, saveCompanyContacts } from "../../../../../services/empresa";
import GenericModal from "../../../../../components/GenericModal";
import helper from "../../../../../utils/helper";

const Contacts = ({ contatos = [], userInfo, fetchCompany }) => {
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [selectedId, setSelectedId] = useState(null);

    const handleSave = async (payload) => {
        await saveCompanyContacts(userInfo.empresa, payload).then((res) => {
            if ((res.status === 200 || res.status === 201) && fetchCompany) {
                fetchCompany();
                helper.dispatchEvent("showAviso", {
                    message: "Contato salvo com sucesso!"
                })
            }
        });
    };

    const openDeleteModal = (id) => {
        setSelectedId(id);
        setShowDeleteModal(true);
    };

    const closeDeleteModal = () => {
        setSelectedId(null);
        setShowDeleteModal(false);
    };

    const confirmDelete = async () => {
        if (!selectedId) return;

        deleteCompanyContacts(userInfo.empresa, selectedId).then(() => {
            if (fetchCompany) {
                fetchCompany();
                helper.dispatchEvent("showAviso", {
                    message: "Contato excluído com sucesso!"
                })
            }
        });

        closeDeleteModal();
    };

    return (
        <>
            <CrudModalList
                title="Contato"
                data={contatos}
                initialState={{
                    contato: "",
                    telefone: "",
                    celular: "",
                    email: ""
                }}
                fields={[
                    { id: "contato", label: "Contato", col: "col-md-12" },
                    { id: "telefone", label: "Telefone", col: "col-md-6" },
                    { id: "celular", label: "Celular", col: "col-md-6" },
                    { id: "email", label: "E-mail", col: "col-md-12" }
                ]}
                columns={[
                    { key: "contato", label: "Contato" },
                    { key: "email", label: "E-mail" }
                ]}
                onSave={handleSave}
                onDelete={(id) => openDeleteModal(id)}
            />

            <GenericModal
                isOpen={showDeleteModal}
                title="Deletar Contato"
                description="Tem certeza que deseja deletar esse contato?"
                onConfirm={confirmDelete}
                onClose={closeDeleteModal}
                isDelete={true}
            />
        </>
    );
};

export default Contacts;